import type { TimeDisplayPreference } from '@/utils/general'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import { Vertical, Texto } from '@gravitate-js/excalibrr'

export type StatusStampOfflineProps = {
  lastSeen: string // the last seen timestamp in ISO format
  lastSeenTz: string // backend provided timezone of the last seen timestamp
  timeDisplayPreference: TimeDisplayPreference
}

export function StatusStampOffline({ lastSeen, lastSeenTz, timeDisplayPreference }: StatusStampOfflineProps) {
  return (
    <Vertical>
      <Texto category='p1' appearance='white'>
        Offline
      </Texto>
      <Texto category='p1' appearance='white'>
        Last Seen: {formatters.SHORT_DATE_TIME(lastSeen, timeDisplayPreference !== 'LOCAL' ? lastSeenTz : undefined)}
      </Texto>
    </Vertical>
  )
}
